import React from 'react';
import lasses from "./loadingSpinner.module.css"

export const LoadingSpinner = () => {
  return (
    <span className={lasses.loader}></span>
  )
}
